import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/context/AuthContext";
import { apiClient } from "@/lib/api/client";

interface UserDetails {
  id: number;
  username: string;
  email: string;
  role: string;
  isVerified: boolean;
  isEmailVerified: boolean;
  fullName?: string;
  phoneNumber?: string;
  bio?: string;
  createdAt: string;
  updatedAt: string;
  createdById?: number;
}

export const useUserDetails = () => {
  const { user } = useAuth();

  const fetchUserDetails = async (): Promise<UserDetails> => {
    const { data } = await apiClient.get(`/api/users/${user?.sub}`);
    return data;
  };

  const { data, isLoading, error } = useQuery({
    queryKey: ["user-details", user?.sub],
    queryFn: fetchUserDetails,
    enabled: !!user?.sub,
  });

  return {
    userDetails: data,
    isLoading,
    error,
  };
};
